const amountOfTaskTimeTrackingEntries = 20;

export default amountOfTaskTimeTrackingEntries;
